export default __webpack_public_path__ + "08acc8cdccf1d08f58c3e82a2a358e4a.svg";